import { render, staticRenderFns } from "./AreasComponent.vue?vue&type=template&id=7fe5b668"
import script from "./AreasComponent.vue?vue&type=script&lang=js"
export * from "./AreasComponent.vue?vue&type=script&lang=js"
import style0 from "./AreasComponent.vue?vue&type=style&index=0&id=7fe5b668&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports